import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const ConfirmationModal = ({
  visible,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  secondaryButtonText,
  onSecondaryPress,
  cancelButtonColor,
  onClosePress,
  onCancelPress,
  onConfirmPress,
  buttontextColor
}) => (
  <Dialog open={visible} onClose={onClosePress}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography>{message}</Typography>
    </DialogContent>
    <DialogActions>
     <Button
        onClick={onCancelPress}
        sx={{
          backgroundColor: cancelButtonColor,
          color: buttontextColor,
          "&:hover": {
            backgroundColor: cancelButtonColor,
            color: buttontextColor,
          },
        }}
      >
        {cancelButtonText}
      </Button>
      {secondaryButtonText ? (
        <Button onClick={onSecondaryPress} variant="outlined" color="error">
          {secondaryButtonText}
        </Button>
      ) : null}
      <Button onClick={onConfirmPress} variant="contained" color="primary">
        {confirmButtonText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
